export default [
    {
      path: '/label/vidcents-wallet',
      name: 'VidCents Wallet Label',
      component: () =>
        import(/* webpackChunkName: 'vidcents-wallet-label' */ './views/Index.vue')
    }
  ]
  